import { render, staticRenderFns } from "./PrintComponent.vue?vue&type=template&id=6bf5368e&scoped=true"
import script from "./PrintComponent.vue?vue&type=script&lang=js"
export * from "./PrintComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf5368e",
  null
  
)

export default component.exports